export function formatDuration(seconds: number) {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function percentile(sorted: number[], p: number): number | null {
  if (!sorted.length) return null;
  const clamped = Math.max(0, Math.min(1, p));
  const idx = Math.floor(clamped * (sorted.length - 1));
  const v = sorted[idx];
  return Number.isFinite(v) ? v : null;
}

